import { IconSizeType } from "@/modules/InfoBoxModule/InfoBoxes/InfoBox";

export const getIconSize = (icon_size: IconSizeType) => {
  return {
    "--icon-size-mobile": `${icon_size.mobile}rem`,
    "--icon-size-tablet": `${icon_size.tablet}rem`,
    "--icon-size-desktop": `${icon_size.desktop}rem`,
    "--icon-size-fullhd": `${icon_size.fullhd}rem`,
  };
};
